import { useState, useEffect } from 'react';

export function useCacheConsent() {
  const [showConsent, setShowConsent] = useState(false);

  useEffect(() => {
    const hasConsent = localStorage.getItem('cache_consent_given');
    if (!hasConsent) {
      setShowConsent(true);
    }
  }, []);

  const closeConsent = () => {
    setShowConsent(false);
  };

  return { showConsent, closeConsent };
}